import * as types from "./mutation_types";

const getLicenses = ({ commit,dispatch }, {loan_officer_selected = null}) => {
    commit(types.TOGGLE_LOADING);
    let url = "/esi/state-license/json";

    if(loan_officer_selected && loan_officer_selected.id) {
        url = "/esi/state-license/lo-json/" + loan_officer_selected.id;
    }

    if(window.location.href.indexOf("localhost") >= 0) {
        url = "http://localhost:9001/app_dev.php" + url;
    }

    fetch(url)
    .then((response) => response.json())
    .then((data) => {
      commit(types.SET_LICENSES, data);
      commit(types.TOGGLE_LOADING);
    })
    .catch((e) => {
      commit(types.TOGGLE_LOADING);
      commit(types.SET_ERROR, e.message);
      dispatch('alert/error', e.message, { root: true });
    });
};


export default getLicenses;
